module.exports = __webpack_public_path__ + "img/vertical_6_5_8019.2f3813a9.png";